module.exports = __webpack_public_path__ + "img/select-item.eee94e68.svg";